/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from "react";
import CalendarSelector from "./components/CalendarSelector";
import TimeSelector from "./components/TimeSlotSelector";
import BookingForm from "./components/BookingForm";
import "./App.css";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import StripePaymentForm from "./components/StripePaymentForm";
import CancelAppointment from "./pages/CancelAppointment";
import { useLocation } from "react-router-dom";

const StepProgress = ({ step, onStepClick }) => {
  const steps = ["Data", "Orario", "Dati", "Pagamento"];
  return (
    <div className="flex flex-wrap justify-center sm:justify-center items-center mb-4 max-w-full overflow-x-auto px-1 text-[10px] sm:text-sm gap-x-1 gap-y-1 whitespace-nowrap">
      {steps.map((label, index) => {
        const current = index + 1;
        const isActive = current === step;
        const isCompleted = current < step;
        return (
          <div
            key={label}
            className="flex items-center cursor-pointer"
            onClick={() => {
              if (onStepClick && current < step) {
                onStepClick(current);
              }
            }}
          >
            <div
              className={`w-7 h-7 sm:w-8 sm:h-8 rounded-full flex items-center justify-center text-white text-xs sm:text-sm font-bold ${
                isCompleted || isActive ? "bg-[#304563]" : "bg-gray-300"
              }`}
            >
              {current}
            </div>
            <div className="ml-1 mr-2 text-[10px] sm:text-sm font-medium">{label}</div>
            {index < steps.length - 1 && <div className="hidden sm:block w-4 h-0.5 bg-gray-300 mx-1"></div>}
          </div>
        );
      })}
    </div>
  );
};
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

function App() {
  const stepRefs = {
    1: useRef(null),
    2: useRef(null),
    3: useRef(null),
    4: useRef(null),
  };
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    fiscalCode: "",
    clientType: "",
    mode: "",
    note: "",
    selectedDate: null,
    selectedTime: null,
  });
  const [paymentStatus, setPaymentStatus] = useState("idle");
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const showModal = true;
  const location = useLocation();

  useEffect(() => {
    // No longer automatically set step here
  }, []);

  if (location.pathname === "/cancel") {
    return <CancelAppointment />;
  }

  return (
    <Elements stripe={stripePromise}>
      <div>
        {showModal && (
          <div className="fixed inset-0 bg-[#304563] bg-opacity-100 overflow-auto flex items-center justify-center z-50">
           <div className="relative bg-white sm:rounded-xl rounded-lg shadow-xl 
  px-2 pt-4 pb-6 w-full max-w-full sm:max-w-xl mx-1 my-4 
  overflow-y-auto overflow-x-hidden max-h-[90vh] transition-all duration-300 ease-in-out
  max-[375px]:px-1 max-[375px]:text-sm">

              <h1 className="text-lg sm:text-xl font-bold text-center mb-6" style={{ color: '#304563' }}>Prenota un Appuntamento</h1>

              <div className="space-y-6 sm:space-y-6 animate-fade-in" ref={stepRefs[step]}>
                {step === 1 && (
                  <div className="transition-opacity duration-500 ease-in-out opacity-100 animate-fade-in">
                    <StepProgress step={step} onStepClick={setStep} />
                    <div className="max-w-sm mx-auto space-y-4 bg-gray-100 p-3 rounded">
                      <CalendarSelector
                        selectedDate={selectedDate}
                        setSelectedDate={(date) => {
                          setSelectedDate(date);
                          setFormData(prev => ({ ...prev, selectedDate: date instanceof Date ? date.toISOString().split('T')[0] : date }));
                          setTimeout(() => {
                            setStep(2);
                          }, 300);
                        }}
                        selectedTime={selectedTime}
                        setSelectedTime={() => {}}
                      />
                    </div>
                  </div>
                )}

                {step === 2 && (
                  <div className="transition-opacity duration-500 ease-in-out opacity-100 animate-fade-in">
                    <StepProgress step={step} onStepClick={setStep} />
                    <div className="max-w-sm mx-auto space-y-4 bg-gray-100 p-3 rounded">
                      <TimeSelector
                        selectedDate={selectedDate}
                        selectedTime={selectedTime}
                        setSelectedTime={(time) => {
                          setSelectedTime(time);
                          setFormData(prev => ({ ...prev, selectedTime: time }));
                          setTimeout(() => {
                            setStep(3);
                          }, 300);
                        }}
                      />
                    </div>
                  </div>
                )}

                {step === 3 && (
                  <div className="transition-opacity duration-500 ease-in-out opacity-100 animate-fade-in">
                    <StepProgress step={step} onStepClick={setStep} />
                    <BookingForm
                      formData={formData}
                      setFormData={setFormData}
                      selectedDate={selectedDate}
                      selectedTime={selectedTime}
                      onCheckout={() => {}}
                      onContinue={() => setStep(4)}
                      onBack={() => setStep(2)}
                      setStep={setStep}
                    />
                  </div>
                )}

                {(step === 4 || step === 5 || step === 6) && (
                  <div className="transition-opacity duration-500 ease-in-out opacity-100 animate-fade-in">
                    <StepProgress step={step > 4 ? 4 : step} onStepClick={setStep} />
                    {(step === 4 || step === 5) && (
                      <>
                        {step === 4 && (
                          <>
                            <StripePaymentForm
                              formData={formData}
                              onPaymentSuccess={() => {
                                console.log("✅ Payment successful. Navigating to step 5.");
                                setPaymentStatus("success");
                                setStep(5);
                              }}
                              onPaymentError={(error) => {
                                console.error("❌ Payment error:", error);
                                setPaymentStatus("error");
                                setStep(6);
                              }}
                            />
                          </>
                        )}
                        {step === 5 && (
                          <div className="max-w-sm mx-auto space-y-6 bg-gray-100 p-6 rounded text-center">
                            <img src="/studiogenise5.png" alt="Studio Genise Logo" className="w-20 h-30 mx-auto mb-6" />
                            <h2 className="text-xl font-bold text-[#304563]">Prenotazione completata con successo!</h2>
                            <p className="text-gray-700 mt-2">
                              Il tuo appuntamento è stato pre-autorizzato correttamente. L'importo verrà addebitato dopo la consulenza.
                            </p>
                            <p className="text-gray-600 text-sm mt-2">
                              Ti abbiamo inviato un'email di conferma con tutti i dettagli.
                            </p>
                            <button
                              className="mt-4 bg-[#304563] text-white px-4 py-2 rounded hover:bg-[#203246] transition"
                              onClick={() => {
                                setStep(1);
                                setFormData({
                                  name: "",
                                  email: "",
                                  phone: "",
                                  fiscalCode: "",
                                  clientType: "",
                                  mode: "",
                                  note: "",
                                  selectedDate: null,
                                  selectedTime: null,
                                });
                              }}
                            >
                              Torna alla prenotazione
                            </button>
                          </div>
                        )}
                      </>
                    )}
                    {step === 6 && (
                      <div className="max-w-sm mx-auto space-y-6 bg-gray-100 p-6 rounded text-center">
                        <img src="/studiogenise5.png" alt="Studio Genise Logo" className="w-20 h-30 mx-auto mb-6" />
                        <h2 className="text-xl font-bold text-[#304563]">Pagamento non riuscito</h2>
                        <p className="text-gray-700 mt-2">
                          Siamo spiacenti, la tua prenotazione non è stata completata perché il pagamento non è andato a buon fine.
                        </p>
                        <p className="text-gray-600 text-sm mt-2">
                          Ti invitiamo a riprovare o a contattarci per assistenza.
                        </p>
                        <button
                          className="mt-4 bg-[#304563] text-white px-4 py-2 rounded hover:bg-[#203246] transition"
                          onClick={() => {
                            setPaymentStatus("idle");
                            setStep(4);
                          }}
                        >
                          Riprova la prenotazione
                        </button>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </Elements>
  );
}

export default App;
